/* Copyright (c) 2017 Backpack Health LLC */
import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';

import RouteNames from '../../../RouteNames';
import * as selectors from '../../../redux/reduxSelectors';

import NavigationActions from '../../../redux/NavigationActions';
import { selectors as groupSelectors, actions as groupActions } from '../../../../redux/ducks/group';
import { actions as userActions } from '../../../../redux/ducks/user';

import LeaveGroup from './LeaveGroup';

function mapStateToProps(state, routerProps) {
  const history = routerProps.history;
  const profileId = selectors.getActiveProfileId(state);
  const profile = selectors.getActiveProfile(state);
  const groupId = Number(routerProps.match.params.groupId);
  const userId = selectors.getLoggedInUser(state).data.id;
  return {
    profile,
    profileId,
    groupActions,
    groupId,
    userId,
    groupName: groupSelectors.getGroup(state, groupId).name,
    isMainProfile: profileId === selectors.getMainProfileId(state),
    onGoBack: () => {
      NavigationActions.goBackTo(history, RouteNames.myGroups());
    },
  };
}

function mapDispatchToProps(dispatch) {
  return {
    onConfirmLeave: (profileId, groupId, userId, callback) => {
      dispatch(groupActions.leaveGroup(profileId, groupId, () => {
        dispatch(userActions.requestUser(userId), callback);
        dispatch(groupActions.requestGroups(profileId));
      }));
      callback();
    },
  };
}

const LeaveGroupWrapper = (props) => (
  <LeaveGroup
    {...props}
    onConfirmLeave={() => {
      props.onConfirmLeave(props.profileId, props.groupId, props.userId, props.onGoBack);
    }}
  />
);
LeaveGroupWrapper.propTypes = {
  profileId: PropTypes.number,
  groupId: PropTypes.number,
  userId: PropTypes.number,
  onConfirmLeave: PropTypes.func,
  onGoBack: PropTypes.func,
};

export default connect(mapStateToProps, mapDispatchToProps)(LeaveGroupWrapper);
